/**
 * RAMS input prerequisite wire schemas — hazards catalogue + custom trade
 * tasks. Input surface only; RAMS generation activation is out of scope.
 */
export * from "./hazards";
export * from "./custom-trade-tasks";
